import { useCallback, useMemo, useState } from 'react';

import { getStorageItem, setStorageItem } from 'utils';

const STORAGE_PREFIX = '@eskolare/table-columns';
const STORAGE_VERSION = 1;
const SAFE_STORAGE_SEGMENT = /^[a-zA-Z0-9_-]+$/;

const sanitizeSegment = (value, fallback) =>
  typeof value === 'string' && SAFE_STORAGE_SEGMENT.test(value.trim()) ? value.trim() : fallback;

function useColumnPreferences({ tableId, scopeKey, columns }) {
  const storageKey = [STORAGE_PREFIX, sanitizeSegment(tableId, 'table'), sanitizeSegment(scopeKey)]
    .filter(Boolean)
    .join('/');

  const stored = useMemo(() => getStorageItem(storageKey, null), [storageKey]);
  const [session, setSession] = useState(null);
  const preferences = session?.key === storageKey ? session.preferences : stored;

  const columnVisibility = useMemo(
    () => ({
      ...Object.fromEntries(
        columns.filter(column => column.defaultVisible === false).map(column => [column.id, false]),
      ),
      ...preferences?.visibility,
    }),
    [columns, preferences],
  );

  const savePreferences = useCallback(
    ({ visibility, order }) => {
      const payload = {
        visibility,
        order,
        version: STORAGE_VERSION,
        updatedAt: new Date().toISOString(),
      };

      setStorageItem(storageKey, payload);
      setSession({ key: storageKey, preferences: payload });
    },
    [storageKey],
  );

  return { columnVisibility, columnOrder: preferences?.order || [], savePreferences };
}

export default useColumnPreferences;
